<template>
  <div>
    <div class="playlist-player" v-if="ready">
      <div class="progress">
        <div class="controls">
          <button v-if="currentIndex > 0" @click="previousTrack(true)">
            <img src="/images/ui/ui_previous.png" alt="Previous Track">
          </button>
          <button v-else>
            <img src="/images/ui/ui_previous-no.png" alt="No Previous Track">
          </button>
          <button v-if=!audioPlaying @click="playPause(true)">
            <img src="/images/ui/ui_play.png" alt="Play Track">
          </button>
          <button v-else @click="playPause(false)">
            <img src="/images/ui/ui_pause.png" alt="Pause Track">
          </button>
          <button v-if="currentIndex < audioTracks.length-1" @click="nextTrack(true)">
            <img src="/images/ui/ui_next.png" alt="Next Track">
          </button>
          <button v-else>
            <img src="/images/ui/ui_next-no.png" alt="No Next Track">
          </button>
        </div>


        <div class="track-info" v-show="audioLoaded">
          <transition name="fade" mode="out-in">
            <div class="credits" v-show="audioLoaded">
              <p>{{ trackTitle }}</p>
              <p>{{ trackArtist }}</p>
            </div>
          </transition>
          <transition name="fade" mode="out-in">
            <div class="time-bar" v-show="durationReady">
              <span class="time">{{ secondsToMinutes(rangeVal) }}</span>
              <input class="bar" type="range" v-model="rangeVal" v-on:change="sliderChange" min="0"
                     v-bind:max="trackDuration" ref="rangeEl"/>
              <span class="time">{{ trackDurationFormatted }}</span>

              <!--
                                      <span class="time" v-show="durationReady">{{ secondsToMinutes(trackDurationFormatted)}}</span>
              -->
            </div>
          </transition>
        </div>
      </div>
    </div>

    <h2>Contents</h2>
    <ul class="contents">
      <li v-for="audioTrack in audioTracks" v-bind:key="audioTrack.index">
        <p>{{ audioTrack.title }}</p>
        <p v-if="audioTrack.artist">{{ audioTrack.artist }}</p>
        <span class="tag" v-if="audioTrack.tag">{{ audioTrack.tag }}</span>
      </li>
    </ul>

    <div class="image">
      <figure v-show="audioLoaded">
        <transition name="fade" mode="out-in">
          <img v-show="audioLoaded" :src="coverPath" alt="track cover">
        </transition>
        <figcaption>
          <p>{{ coverCredit }}</p>
        </figcaption>
      </figure>
    </div>

  </div>
</template>

<script>
import {bus} from "@/main";

export default {
  name: "AudioPlaylistPlayer",
  props: {
    audioSrc: String,
  },
  data() {
    return {
      audioTrack: null,
      trackDuration: null,
      trackDurationFormatted: null,
      audioPlaying: false,
      audioLoaded: false,
      durationReady: false,
      rangeVal: 0,
      justCreated: true,
      audioTracks: [],
      trackTitle: '',
      trackArtist: '',
      coverPath: '',
      coverCredit: '',
      currentIndex: 0,
      ready: false,
    }
  },
  methods: {

    playPause(toPlay) {

      if (this.justCreated) {
        this.audioTrack = new Audio()
        this.audioTrack.src = this.audioTracks[this.currentIndex].path
        this.trackTitle = this.audioTracks[this.currentIndex].title
        this.trackArtist = this.audioTracks[this.currentIndex].artist
        this.coverPath = this.audioTracks[this.currentIndex].cover
        this.coverCredit = this.audioTracks[this.currentIndex].covercredit
        this.justCreated = false
        this.establishListeners()
      }

      this.audioPlaying = toPlay
      if (toPlay) {
        this.audioTrack.play()
      } else {
        this.audioTrack.pause()
      }
    },

    establishListeners() {
      setTimeout(this.addListeners.bind(this), 250)
    },

    async addListeners() {
      this.audioTrack.addEventListener('timeupdate', this.audioChange.bind(this), false)
      this.audioTrack.addEventListener('ended', this.trackEnded.bind(this), false)
      this.trackDurationFormatted = this.secondsToMinutes(this.audioTrack.duration)
      this.trackDuration = this.audioTrack.duration
      this.audioLoaded = true
      setTimeout(this.validateDuration.bind(this), 150)

    },
    validateDuration() {
      if (this.trackDurationFormatted == "NaN:aN" || this.trackDurationFormatted == "0:00") {
        this.trackDurationFormatted = this.secondsToMinutes(this.audioTrack.duration)
        setTimeout(this.validateDuration.bind(this), 150)
      } else {
        this.durationReady = true
      }
    },
    removeListeners() {
      this.audioTrack.removeEventListener('timeupdate', this.audioChange.bind(this), false)
      this.audioTrack.removeEventListener('ended', this.trackEnded.bind(this), false)
      this.trackDurationFormatted = "0:00"
    },

    previousTrack() {
      this.currentIndex--
      this.trackSwitch()
    },

    nextTrack() {
      this.currentIndex++
      this.trackSwitch()

    },

    trackSwitch() {
      this.playPause(false)
      this.removeListeners()
      this.audioLoaded = false
      this.justCreated = true
      this.playPause(true)

    },

    audioChange() {
      this.rangeVal = this.audioTrack.currentTime
    },

    sliderChange() {
      this.rangeVal = this.$refs.rangeEl.value
      this.audioTrack.currentTime = this.rangeVal
    },

    trackEnded() {
      this.rangeVal = 0
      this.audioPlaying = false
    },

    secondsToMinutes(seconds) {
      if (seconds == null) return; //isNan(seconds)
      try {
        //let secondsConverted = Number(seconds.toFixed(0))
        let secondsConverted = Math.round(seconds * 100) / 100
        return Math.floor(secondsConverted / 60) + ':' + ('0' + Math.floor(secondsConverted % 60)).slice(-2);
      } catch (err) {
        return '0:00';
      }
    },

    receiveAudio(arrayPassed) {
      this.audioTracks = arrayPassed
      //console.log(this.audioTracks[this.currentIndex].path)
      this.ready = true
    },

  },
  // start receiving from AudioPlaylistPlayer
  created() {
    bus.$on('postAudio', this.receiveAudio);
  },

  // unsubscribe on destroy
  beforeDestroy() {
    bus.$off('postAudio')
    this.playPause(false)
  },


}
</script>

<style scoped>
.image {
  margin: 0 auto;
  padding: 1em 0;
  width: 75vw;
  height: 75vw;
  max-width: 100%;
  max-height: 32em;
  pointer-events: all;
}

.contents {
  pointer-events: all;
}

@media screen and (min-width: 1060px) {
  .image {
    padding: 1em;
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: calc(100vw - 32em - (2 * 1em));
    height: calc(100vw - 32em - (2 * 1em));
  }
}

@media screen and (min-width: 1350px) {
  .image {
    padding: 1em;
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: calc(100vw - 36em - (2 * 1em));
    height: calc(100vw - 36em - (2 * 1em));
  }
}

.image figure {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0;
  font-size: .7em;
}

.image img {
  height: auto;
  width: auto;
  max-width: 100%;
  max-height: 100%;
}

.contents {
  padding-left: 0;
}

.contents li {
  padding-bottom: 1.25em;
  list-style: none;
}

.contents p {
  margin: 0;
}

.contents p:first-of-type {
  font-weight: bold;
}

.contents .tag {
  font-size: .7em;
  padding: .07em .5em;
  border-radius: .25em;
  border: 1px solid var(--darkest);
  margin-right: 1em;
}

.playlist-player {
  position: fixed;
  bottom: 0;
  left: 0;
  width: calc(100% - (.3em * 2));
  padding: .3em;
  background-color: var(--modal-back);
  display: flex;
  justify-content: space-between;
  z-index: 5;
  border-top: 1px solid var(--darkest);
}

.progress {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.controls {
  min-width: 6em;
  width: 6em;
}

.controls button {
  width: 2em;
  font: inherit;
  background: none;
  color: inherit;
  border: none;
  padding: 0.4em 0;
  cursor: pointer;
  outline: inherit;
}

.controls img {
  padding: 0;
  margin: 0 auto;
  width: 45px;
  height: 45px;
  display: block;
}

.track-info {
  padding-left: .35em;
}

.credits p {
  font-size: .65em;
  line-height: 1;
  margin: 0;
}

.credits p:first-of-type {
  font-weight: bold;
}

.time {
  padding: 0;
  font-size: .65em;
}

.time:first-of-type::after {
  content: '/';
}

input {
  display: none;
}

@media screen and (min-width: 660px) {
  .contents {
    display: flex;
    flex-wrap: wrap;
  }

  .contents li {
    width: calc(50% - (.75em * 2));
    padding-bottom: 1.25em;
  }

  .contents li:nth-child(odd) {
    padding-right: .75em;
  }

  .contents li:nth-child(even) {
    padding-left: .75em;
  }

  .track-info {
    padding-left: 1em;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-grow: 2;
  }

  .time-bar {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 2;
  }

  .credits {
    padding-right: 1em;
  }

  .credits p {
    font-size: 1em;
    line-height: 1;
    margin: 0;
  }

  .time {
    padding: 0 .75em;
    font-size: 1em;
  }

  .time:first-of-type::after {
    content: none;
  }

  /* SLIDER STYLES */
  input {
    display: block;
    background-color: var(--modal-back);
    width: 100%;
  }

  /* DOT */
  /* Special styling for WebKit/Blink */
  input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
    border: 1px solid var(--darkest);
    height: 1em;
    width: 1em;
    border-radius: 50%;
    background: var(--darkest);
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -.2em;
    /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
    box-shadow: 1px 1px 1px var(--darkest), 0px 0px 1px var(--darkest);
    /* Add cool effects to your sliders! */
  }

  /* All the same stuff for Firefox */
  input[type=range]::-moz-range-thumb {
    box-shadow: 1px 1px 1px var(--darkest), 0px 0px 1px var(--darkest);
    border: 1px solid var(--darkest);
    height: 1em;
    width: 1em;
    border-radius: 50%;
    background: var(--darkest);
    cursor: pointer;
  }

  /* All the same stuff for IE */
  input[type=range]::-ms-thumb {
    box-shadow: 1px 1px 1px var(--darkest), 0px 0px 1px var(--darkest);
    border: 1px solid var(--darkest);
    height: 1em;
    width: 1em;
    border-radius: 50%;
    background: var(--darkest);
    cursor: pointer;
  }

  /* TRACK */
  input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 8.4px;
    cursor: pointer;
    background: rgb(170, 170, 170);
  }

  input[type=range]:focus::-webkit-slider-runnable-track {
    background: rgb(170, 170, 170);
  }

  input[type=range]::-moz-range-track {
    width: 100%;
    height: 8.4px;
    cursor: pointer;
    background: rgb(170, 170, 170);
  }

  input[type=range]::-ms-track {
    width: 100%;
    height: 8.4px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    border-width: 16px 0;
    color: transparent;
  }

  input[type=range]::-ms-fill-lower {
    background: rgb(170, 170, 170);
  }

  input[type=range]:focus::-ms-fill-lower {
    background: rgb(170, 170, 170);
  }

  input[type=range]::-ms-fill-upper {
    background: rgb(170, 170, 170);
  }

  input[type=range]:focus::-ms-fill-upper {
    background: rgb(170, 170, 170);
  }

  /* SLIDER END */
}


</style>
